import { render, staticRenderFns } from "./editAddressDialog.vue?vue&type=template&id=38c06d41&scoped=true"
import script from "./editAddressDialog.vue?vue&type=script&lang=js"
export * from "./editAddressDialog.vue?vue&type=script&lang=js"
import style0 from "./editAddressDialog.vue?vue&type=style&index=0&id=38c06d41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c06d41",
  null
  
)

export default component.exports